import { ClassDirective } from './class.directive';
import { ClickOutsideDirective } from './click-outside.directive';

export const SHARED_DIRECTIVES = [ClickOutsideDirective, ClassDirective];
